import { SnackbarProvider } from "notistack";
import { SnackbarNotification } from "components/UI/molecules";
import errorIcon from "assets/icons/snackbar/error.svg";

export const SnackbarNotificationProvider = ({ children }) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      anchorOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      Components={{
        error: SnackbarNotification,
        success: SnackbarNotification
      }}
      iconVariant={{
        error: (
          <img className="snackbar-icon" src={errorIcon} alt="Error icon" />
        )
      }}
      TransitionProps={{
        style: { transition: "none" },
        unmountOnExit: true,
        exit: false
      }}
      transitionDuration={0}
    >
      {children}
    </SnackbarProvider>
  );
};
